import { render, staticRenderFns } from "./layer-add-shops-contract.vue?vue&type=template&id=11708e66&scoped=true&"
import script from "./layer-add-shops-contract.vue?vue&type=script&lang=js&"
export * from "./layer-add-shops-contract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11708e66",
  null
  
)

export default component.exports